import DeleteIcon from '@material-ui/icons/Delete';
import { withProps } from 'recompose';
import IconButton from './icon_button';

export default withProps(() => ({ IconComponent: DeleteIcon }))(IconButton);
